import { analytics, performance } from "../../firebase.ts";
import { trace, PerformanceTrace } from "firebase/performance";
import { logEvent } from "firebase/analytics";
import { HeartBank } from "../../managers/HeartBank.ts";

import { SwHeader } from "../sw-header/sw-header.ts";
import { SwFooter } from "../sw-footer/sw-footer.ts";
import { SwHome } from "./sw-home/sw-home.ts";
import { SwPage } from "./sw-page/sw-page.ts";
import { SwMap } from "./sw-map/sw-map.ts";

import template from "./sw-main.mjs";
import Strings from "../../models/Strings.json";
import { LANGUAGE, isProduction } from "../global.ts";
//import { MINOR_VERSION } from "../../sw.ts";

const strings: any = Strings;

export class SwMain extends HTMLElement {
    private heartbank = new HeartBank();
    private componentTrace: PerformanceTrace;

    private header = document.querySelector("sw-header") as SwHeader;
    private footer = document.querySelector("sw-footer") as SwFooter;

    private home: SwHome;
    private page: SwPage;
    private map: SwMap;

    constructor() {
        super();
        this.componentTrace = trace(performance, "component");
        this.componentTrace.putAttribute("view", "sw-main");
        this.componentTrace.start();
        this.appendChild(template.content.cloneNode(true));

        this.home = this.querySelector("sw-home")!;
        this.page = this.querySelector("sw-page")!;
        this.map = this.querySelector("sw-map")!;
    }

    connectedCallback() {
        const minor = document.querySelector('meta[name="minor"]')!;

        // always on bc not sure; maybe can move and do if user cancel update
        if (
            minor.getAttribute("content") !==
            localStorage.getItem("updateAvailable")
        ) {
        }
        setInterval(
            () => {
                if (localStorage.getItem("updateAvailable"))
                    this.showUpdatePrompt();
            },
            isProduction ? 60000 * 60 : 3000
        ); // 1 hour

        navigator.serviceWorker.addEventListener("message", (event) => {
            if (
                minor.getAttribute("content") !== event.data.version // MINOR_VERSION doesn't work
            ) {
                if (isProduction) {
                    localStorage.setItem("updateAvailable", event.data.version);
                    this.showUpdatePrompt();
                }
            }
        });

        // window.addEventListener("resize", () => {
        //     this.style.touchAction =
        //         window.visualViewport?.scale !== 1 ? "auto" : "pinch-zoom";
        // });

        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }

    // might not be necessary bc browser does it automatically
    //TODO: later use flowbite dialogue? // confirm is cool bc it interrupts the user!
    private async showUpdatePrompt() {
        const userResponse = confirm(strings.refresh[LANGUAGE]);
        if (userResponse) {
            document.body.style.visibility = "invisible";
            localStorage.removeItem("updateAvailable");
            await this.unregisterAllServiceWorkers();
            window.location.reload(); //TODO: check bc might be redundant bc browser auto refresh ?
        } else {
            //setTimeout(this.showUpdatePrompt.bind(this), 60000 * 60); // Retry after 1 hour
        }
        logEvent(analytics, "update", { response: userResponse });
    }

    private async unregisterAllServiceWorkers(): Promise<void> {
        if ("serviceWorker" in navigator) {
            try {
                const registrations =
                    await navigator.serviceWorker.getRegistrations();
                for (const registration of registrations) {
                    const success = await registration.unregister();
                    if (success) {
                        console.warn("Service worker unregistered.");
                    } else {
                        console.error(
                            "Failed to unregister the service worker."
                        );
                    }
                }
            } catch (error) {
                console.error(
                    "Error fetching service worker registrations: ",
                    error
                );
            }
        } else {
            console.warn("Service workers are not supported in this browser.");
        }
    }

    // TODO: show some views on the current page without going to the home page
    homeTo(view: string) {
        this.header.show();
        this.footer.show();

        switch (view) {
            case "#ai": // sw // app dialog on home page TODO: move to sw-bedok?
                this.showHome();
                this.soon();
                break;
            case "#333": // 333 // deprecated: tuk tuk dialog on map page TODO: move to sw-bedok?
                this.showMap();
                this.soon();
                break;
            case "#heartbank": // hb
                this.showHome();
                break;
            case "#readership": // th
                this.showMap();
                break;
            case "#share":
                this.showHome(true);
                break;
            default:
                if (this.heartbank.user) this.showMap();
                else this.showHome();
        }

        //window.addEventListener("keydown", this.toggleFullScreen.bind(this));
    }

    private showHome(scroll: boolean = false) {
        this.header.showHome();
        this.footer.showHome();
        this.home.show();
        this.page.hide();
        this.map.hide();
        this.home.play();

        if (scroll) {
            const target = document.getElementById(
                "scroll-to-here"
            ) as HTMLElement;
            this.home.scrollTo({
                top: target.offsetTop,
                behavior: "smooth"
            });
        } else
            this.home.scrollTo({
                top: 0,
                behavior: "smooth"
            });
    }

    private showMap() {
        this.header.showMap(); // default map view = now
        this.footer.showMap();
        this.home.hide();
        this.page.hide();
        this.map.show();
        this.home.pause();
    }

    // showPage
    pageTo(book: number, page: number) {
        this.header.showPage();
        this.footer.showPage();
        //this.header.show();
        //this.footer.show();

        this.page.show();
        this.home.hide();
        this.map.hide();
        this.home.pause();
        this.page.goTo(book, page);

        //window.removeEventListener("keydown", this.toggleFullScreen.bind(this));
    }

    // weird bug in desktop
    private toggleFullScreen(event: KeyboardEvent) {
        if (event.code === "Space" || event.key === " ") {
            if (this.header.classList.contains("hidden")) {
                this.header.show();
                this.footer.show();
            } else {
                this.header.hide();
                this.footer.hide();
            }
            // prevent scrolling if needed
            event.preventDefault();
        }
    }

    private soon() {
        this.dispatchEvent(
            new CustomEvent<{ info: string }>("sw-banner", {
                bubbles: true,
                detail: {
                    info: strings.soon[LANGUAGE]
                }
            })
        );
    }
}
